import { type IconType } from "@clipboard-health/ui-components";
import { type TierType, tierTypeSchema } from "@src/appV2/redesign/Tiers/api/schema";
import { type EventDescriptionKey } from "@src/appV2/redesign/Tiers/utils/types";

export const TIER_ICONS: Record<TierType, IconType> = {
  GOLD: "membership-gold-colored",
  SILVER: "membership-silver-colored",
  LIMITED: "membership-limited-colored",
};

export const WORKER_FACING_TIER_NAME: Record<TierType, string> = {
  GOLD: "Gold",
  SILVER: "Silver",
  LIMITED: "Limited",
};

export const RATINGS_COLUMN_WIDTH = 80;
export const RATINGS_ICON_WIDTH = 50;

export const DEFAULT_LATE_CANCELLATION_THRESHOLD_IN_HOURS = 24;

export const CLOSE_TO_RATING_THRESHOLD = 20;

export const BULLET_POINT = "◆";

// By default, we should have basket size limitations for Limited tier.
export const DEFAULT_ENABLED_BASKET_SIZE_LIMIT_CONFIGURATION = {
  limited: {
    enabled: true as const,
    scoreThreshold: 10_000, // unused
    basketSize: 1,
    leadTimeThresholdInHrs: 120,
    shiftRequirements: ["CNA", "LVN", "RN", "NURSE", "CAREGIVER"],
  },
  warning: { enabled: false as const },
};

export const DEFAULT_TIERS_WINDOWING_CONFIGURATION = {
  maxWindowDurationInHours: 2,
  minLeadTimeInMinutesToTriggerWindowCreation: -120,
  minWindowDurationInMinutes: 10,
  minWorkersToTriggerWindowCreation: 0,
  minimumViewThresholdPercentageForSkipping: 100,
  shiftLeadTimeMultiplier: 0.1,
  shouldSkipBasedOnViews: false,
};

// Build all possible EventDescriptionKey combinations dynamically
const EVENT_IS_SUCCESS_KEYS = ["true", "false"] as const;
const TIER_TYPES = tierTypeSchema.options;

export const EMPTY_DESCRIPTION_MAP: Record<EventDescriptionKey, undefined> = (() => {
  const emptyMap: Record<string, undefined> = {};

  for (const isSuccess of EVENT_IS_SUCCESS_KEYS) {
    for (const currentTier of TIER_TYPES) {
      for (const newRatingTier of TIER_TYPES) {
        for (const previousRatingTier of TIER_TYPES) {
          const key: EventDescriptionKey = `${isSuccess}-${currentTier}-${newRatingTier}-${previousRatingTier}`;
          emptyMap[key] = undefined;
        }
      }
    }
  }

  const typedEmptyMap: Record<EventDescriptionKey, undefined> = emptyMap;
  return typedEmptyMap;
})();

export const TIERS_PERKS_SECTION_ID = "membership-perks";

export const TIERS_QUERY_KEY = "tiers";
export const TIERS_CARD_IMAGE_SIZE = 210;
export const TIERS_CARD_IMAGE_PADDING = 110;

export const LATE_CANCEL_PROTECTION_PERIOD_IN_HOURS = 24;
export const LATE_CANCEL_PROTECTION_SHIFT_PAYOUT_IN_HOURS = 2;
